import React from 'react';
import { getMentoringPageContent } from '../mentoringContent';
import {
  ActionLink,
  Card,
  CardGrid,
  Hero,
  Section,
} from '../components/MentoringPrimitives';
import { MentoringPageShell } from './shared';

const ProjectCard = ({ project, locale }) => (
  <Card
    tag={project.tag}
    title={project.title}
    text={project.text}
    href={project.href}
    linkLabel={locale === 'fr' ? 'Voir le produit' : 'Visit product'}
  />
);

const ProjectsBody = ({ locale }) => {
  const content = getMentoringPageContent(locale, 'projects');

  if (!content) {
    return null;
  }

  const { hero, teamProjects, footprint, employers } = content;

  return (
    <>
      <Hero {...hero} split />

      <Section
        marker={teamProjects.marker}
        eyebrow={teamProjects.eyebrow}
        title={teamProjects.title}
        lead={teamProjects.lead}
      >
        <CardGrid cols={3}>
          {teamProjects.items.map((project) => (
            <ProjectCard key={project.key} project={project} locale={locale} />
          ))}
        </CardGrid>
      </Section>

      <Section
        marker={footprint.marker}
        eyebrow={footprint.eyebrow}
        title={footprint.title}
        lead={footprint.lead}
        tone="paper2"
      >
        <div className="mt-table-scroll">
          <table className="mt-table">
            <caption className="mt-skip">{footprint.tableTitle}</caption>
            <thead>
              <tr>
                <th scope="col">{footprint.columns.repository}</th>
                <th scope="col">{footprint.columns.classification}</th>
                <th scope="col">{footprint.columns.language}</th>
              </tr>
            </thead>
            <tbody>
              {footprint.rows.map((row) => (
                <tr key={row.repository}>
                  <th scope="row">{row.repository}</th>
                  <td>{row.classification}</td>
                  <td><a href={row.href} target="_blank" rel="noopener noreferrer">{row.language} ↗</a></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-section__actions">
          <a
            href={footprint.link.href}
            className="mt-link"
          >
            {footprint.link.label}
            <span aria-hidden="true">↗</span>
          </a>
        </div>
      </Section>

      <Section
        marker={employers.marker}
        eyebrow={employers.eyebrow}
        kicker={employers.kicker}
        title={employers.title}
        lead={employers.lead}
        tone="ink"
      >
        <div className="mt-section__actions">
          <ActionLink action={employers.cta} variant="on-dark" />
        </div>
      </Section>
    </>
  );
};

export default function MentoringProjectsPage({ locale }) {
  return (
    <MentoringPageShell locale={locale} pageKey="projects">
      <ProjectsBody locale={locale} />
    </MentoringPageShell>
  );
}
